import fetcher from './fetcher';

export function get() {
    return fetcher('/translations');
}

export function update(payload) {
    return fetcher.put(`/translations`, payload);
}
